import { CaptureMode } from './CaptureMode';
import { UploadZone } from '../upload-zone';
import { CameraCapture } from '../camera-capture';
import { ImagePreview } from '../preview/ImagePreview';

export function CaptureSection({ mode, setMode, onImageCapture, imageData }) {
  return (
    <div className="space-y-6">
      <CaptureMode mode={mode} setMode={setMode} />
      {mode === 'upload' ? (
        <UploadZone onImageUpload={onImageCapture} />
      ) : (
        <CameraCapture onImageCapture={onImageCapture} />
      )}
      <ImagePreview imageData={imageData} />
    </div>
  );
}